import { throttle } from '../decorators';
import Viewport from "../common/viewport";

const SCROLL_TO_TOP_BUTTON_CLASS = 'scroll-to-top';
const SCROLL_TO_TOP_VISIBLE_BUTTON_CLASS = 'scroll-to-top--visible';

/**
 * @return {HTMLButtonElement}
 */
const makeButton = () => {
    const button = document.createElement('button');
    button.setAttribute('data-hide-on-slideout', '');
    button.classList.add(SCROLL_TO_TOP_BUTTON_CLASS);
    document.body.appendChild(button);
    return button;
}

/**
 * @param {Function} onScrollToTop
 */
export const initScrollToTopButton = (onScrollToTop) => {
    /** Check if button already exists */
    if (document.getElementsByClassName(SCROLL_TO_TOP_BUTTON_CLASS).length > 0) {
        return;
    }

    const viewport = new Viewport();
    const button = makeButton();
    
    button.addEventListener('click', () => {
        viewport.scrollTop = 0;
        if (onScrollToTop instanceof Function) {
            onScrollToTop();
        }
    });

    const updateButtonVisibility = () => {
        if (viewport.height > viewport.scrollTop) {
            button.classList.remove(SCROLL_TO_TOP_VISIBLE_BUTTON_CLASS);
        } else {
            button.classList.add(SCROLL_TO_TOP_VISIBLE_BUTTON_CLASS);
        }
    };

    window.addEventListener('scroll', throttle(updateButtonVisibility, 100));
    updateButtonVisibility();
}
